import React, { useState } from 'react';
import OrderItem from '../../api/models/addOnTesting/ShoppingCart';
import { useTranslation } from 'react-i18next';
import { Form, Tab, Table } from 'react-bootstrap';
import { CaretDownFill } from 'react-bootstrap-icons';

interface PanelTableProps {
  items: OrderItem[]
  selectedPanels: number[]
  onExpand: (item: OrderItem) => void
  onSelect?: (panels: number[]) => void
}

export const PanelTable = (props: PanelTableProps) => {
  const { items, selectedPanels, onExpand } = props

  //const [selectedPanels, setSelectedPanels] = useState<number[]>([])

  const handleCheckboxChange = (value: number) => {
    const isChecked = selectedPanels.some(panel => panel === value)
    const newSelected = isChecked ? selectedPanels.filter(panel => panel !== value) : selectedPanels.concat(value)
    //setSelectedPanels(newSelected)
    props.onSelect && props.onSelect(newSelected)
  }

  return (
    <Table responsive hover className="align-middle">
      <tbody>
        {items.map(item => <React.Fragment key={`fragment-${item.addOnTestingPanelId}`}>
          <tr key={item.addOnTestingPanelId} className="border-b last:border-0 hover:bg-gray-50 transition duration-150">
            <td className="py-3 px-4">
              {props.onSelect && <Form.Check aria-label={item.name} id={`item-${item.addOnTestingPanelId}`}
                checked={selectedPanels.some(panel => panel === item.addOnTestingPanelId)}
                onChange={() => handleCheckboxChange(item.addOnTestingPanelId ?? 0)}
              />}
            </td>
            <td className="py-3 px-4">
              <Form.Label htmlFor={`item-${item.addOnTestingPanelId}`}>{item.name}</Form.Label>
            </td>
            <td className="py-3 px-4 text-gray-700">${item.itemPrice.toFixed(2)}</td>
            <td className="text-end">
              <CaretDownFill className="text-primary" size={40} type="button" role="button" onClick={() => onExpand(item)} />
            </td>
          </tr>
        </React.Fragment>)}
      </tbody>
    </Table>
  )
}


